import { ISliderIndents } from '../../types';

interface IGetAdditionalOffsetParams {
  slide: number;
  additionalOffset: number;
  indents: ISliderIndents;
  lastSlide: number;
}

export function getAdditionalOffset(params: IGetAdditionalOffsetParams): number {
  const { slide, lastSlide, additionalOffset, indents } = params;
  const { left = 0, right = 0 } = indents;

  if (slide === 0) {
    return left;
  }

  if (slide === lastSlide) {
    return right;
  }

  return additionalOffset;
}
